'use client'

import Alert from '@dd3tech/wiggui/Alert'
import Button from '@dd3tech/wiggui/Button'
import Checkbox from '@dd3tech/wiggui/Checkbox'
import TextArea from '@dd3tech/wiggui/TextArea'
import Modal from '@dd3tech/wiggui/Modal'
import Text from '@dd3tech/wiggui/Text'
import { useHandleReasonStep } from './hooks/useHandleReasonStep'
import { useHandleSoldStep } from './hooks/useHandleSoldStep'

export const ModalDeleteProperty = () => {
  const {
    allCheckboxsAreFalse,
    dataCheckboxsRadio,
    modalProperty,
    onClose,
    optionOtherIsChecked,
    setDataCheckboxsRadio,
    setTextAreaValue,
    textAreaValue,
    isLoading,
    selectedByOption,
    setSelectedByOption,
    handleActionProperties,
    currentStep,
    optionSoldIsChecked,
    title
  } = useHandleReasonStep({ type: 'DELETE' })

  const { OPTIONS_STEP_SOLD, soldTitle, handleChangeByOption } =
    useHandleSoldStep({
      setSelectedByOption
    })

  if (!modalProperty?.isOpen) {
    return null
  }

  return (
    <Modal
      className="w-full max-w-lg"
      enableBgBlur
      onClose={isLoading ? () => ({}) : onClose}
      isOpen={modalProperty?.isOpen}
    >
      <Modal.Header
        title="Eliminar propiedad"
        isShowCloseButton
        isShowDivider
      />
      <Modal.Body className="p-6 w-full flex gap-6 flex-col items-start justify-center">
        {currentStep === 1 && (
          <>
            <Text className="text-primary text-body-m w-full" align="left">
              {title}
            </Text>
            <div className="w-full flex flex-col items-start justify-start gap-6">
              {dataCheckboxsRadio?.map((checkbox) => {
                const handleOnChange = (isChecked: boolean) => {
                  const newDataCheckboxs = dataCheckboxsRadio?.map((item) => {
                    if (item?.label === checkbox?.label) {
                      return {
                        ...item,
                        isChecked
                      }
                    }

                    return {
                      ...item,
                      isChecked: false
                    }
                  })

                  setDataCheckboxsRadio(newDataCheckboxs)
                }

                return (
                  <Checkbox
                    key={checkbox?.id}
                    label={checkbox?.label}
                    labelClassName="text-primary text-body-bold-m w-full hover:font-bold"
                    containerClassName="w-full items-center justify-center flex flex-row"
                    inputClassName="min-w-[24px]"
                    id={checkbox?.label}
                    name={checkbox?.label}
                    type="radio"
                    isChecked={checkbox?.isChecked}
                    onChange={handleOnChange}
                  />
                )
              })}
              {optionOtherIsChecked && (
                <TextArea
                  className="w-full"
                  containerClassName="w-full"
                  maxCharacters={140}
                  placeholder="Escribe la razón..."
                  value={textAreaValue}
                  setValue={setTextAreaValue}
                />
              )}
            </div>
          </>
        )}
        {currentStep === 2 && (
          <>
            <Text className="text-primary text-body-m w-full" align="left">
              {soldTitle}
            </Text>
            <div className="w-full flex flex-col items-start justify-start gap-6">
              {OPTIONS_STEP_SOLD?.map((option) => {
                const isChecked = option?.value === selectedByOption
                return (
                  <Checkbox
                    key={option?.value}
                    label={option?.label}
                    labelClassName="text-primary text-body-bold-m w-full hover:font-bold"
                    containerClassName="w-full items-center justify-center flex flex-row"
                    inputClassName="min-w-[24px]"
                    id={option?.label}
                    name={option?.label}
                    type="radio"
                    isChecked={isChecked}
                    onChange={() => handleChangeByOption(option?.value)}
                  />
                )
              })}
            </div>
          </>
        )}
        <Alert
          padding="p-3"
          type="neutral"
          className="w-full"
          containerIconClassName="[&>span]:!text-primary items-center flex justify-start w-full !gap-3"
          containerTextClassName="[&>p]:!text-body-bold-m"
          title="Este cambio puede tardar en verse reflejado"
        />
      </Modal.Body>
      <Modal.Footer
        className="w-full py-[9px] px-6 flex flex-row gap-2 items-center justify-center"
        isShowDivider
      >
        <Button
          variant="terciary"
          fullWidth
          onClick={isLoading ? undefined : onClose}
        >
          Cancelar
        </Button>
        <Button
          variant="secondary"
          fullWidth
          isLoading={isLoading}
          onClick={handleActionProperties}
          isDisabled={
            allCheckboxsAreFalse ||
            (optionOtherIsChecked && textAreaValue?.length <= 5) ||
            (currentStep === 2 && !selectedByOption)
          }
        >
          {currentStep === 1 && optionSoldIsChecked ? 'Siguiente' : 'Eliminar'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
